import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeedbackApiBase } from './feedback-api-base';
import { AiReview, AiReviewStatus, DataEnvelope } from '../models';

/**
 * Mirrors App\Http\Controllers\AiReviewController — the AI review log: every AI
 * review process (reviews, link and copy checks, audits) run against a project.
 */
@Injectable({ providedIn: 'root' })
export class AiReviewService extends FeedbackApiBase {
  /**
   * GET /v1/feedback-rounds/{feedbackRoundId}/ai-reviews — the project's AI
   * reviews, newest first (at most 100), optionally only those with `status`.
   */
  listAiReviews(feedbackRoundId: string, status?: AiReviewStatus): Observable<AiReview[]> {
    return this.http
      .get<DataEnvelope<AiReview[]>>(this.url(`feedback-rounds/${feedbackRoundId}/ai-reviews`), {
        params: status ? { status } : {},
      })
      .pipe(map((response) => response.data));
  }
}
